import axios from 'axios';

/**
 * ApiClient, provides shared axios instance
 */
export default class ApiClient {
  /**
   * shared axios instance
   */
  static _client = axios.create({
    baseURL: process.env.REACT_APP_API_DOMAIN,
    headers: {
      Accept: 'application/json',
    }
  });

  constructor(onRequest, onSuccess, onReject) {
    this._onRequest = onRequest || null;
    this._onSuccess = onSuccess || null;
    this._onReject = onReject || null;

    ApiClient._client.interceptors.response.use(null, function (error) {
      // if (error && error.response && 401 === error.response.status &&
      //   window.location.pathname !== '/') {
      //   window.location = '/';
      // }

      throw error;
    });

    let jwtToken = localStorage['jwtToken'];
    if (jwtToken) {
      this.setAuthorizationToken(jwtToken);
    }
  }

  setAuthorizationToken(token) {
    if(token) {
      localStorage.setItem('jwtToken', token);
      axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
    } else {
      delete localStorage['jwtToken'];
      delete axios.defaults.headers.common['authorization'];
    }
  }

  api() {
    return ApiClient._client;
  }

  async apiWrapper(promise) {
    if (this._onRequest) {
      this._onRequest();
    }

    promise.then(
      // On success
      response => {
        if (this._onSuccess) {
          this._onSuccess();
        }
      },
      // On reject
      response => {
        if (this._onReject) {
          this._onReject();
        }
      }
    );

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/store/ApiClient.js